import { generateSkinDefaults } from '@wix/editor-elements-panel';

import type { SiteAssetsSkinParams } from '../TextEffectsShared/TextEffectsShared.skinParams';
import { textEffectsSharedSkin } from '../TextEffectsShared/TextEffectsShared.skinParams';

export const TextEffectsRetroSkin = {
  ...textEffectsSharedSkin,
  'disable-inner-animation': {
    type: 'CSSString',
  },
  'inner-animation-speed': {
    type: 'ALPHA',
    defaultValue: '18.5',
  },
  'bevel-angle': {
    type: 'CSSString',
    defaultValue: '180deg',
  },
  'bevel-depth': {
    type: 'NUMBER',
    defaultValue: '30',
  },
  'layer-count': {
    type: 'NUMBER',
    defaultValue: '4',
  },
  'shadow-blur': {
    type: 'NUMBER',
    defaultValue: '0',
  },
  'text-effects-color-1': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'text-effects-color-2': {
    type: 'COLOR',
    defaultValue: '#1a1a1a',
  },
  'text-effects-color-3': {
    type: 'COLOR',
    defaultValue: '#333333',
  },
  'text-effects-color-4': {
    type: 'COLOR',
    defaultValue: '#4d4d4d',
  },
} as const satisfies SiteAssetsSkinParams;

const TextEffectsRetroSkinDefinitionMap: Record<string, SiteAssetsSkinParams> =
  {
    'wixui.skins.TextEffectsRetro': TextEffectsRetroSkin,
  };

export default generateSkinDefaults(TextEffectsRetroSkinDefinitionMap);
